module.exports = __webpack_public_path__ + "static/L5Y4-4333670289afeef71800d845e2b999ae.jpg";